import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { FleetPage } from '../../../../shared/sso-workspace/fleet-page'
import { RoutesTab } from './routes-tab'
import { TargetsTab } from './targets-tab'
import { RunsTab } from './runs-tab'
import { SSOCoverageTab } from './sso-coverage-tab'

export const TABS = [
  { key: 'routes', label: 'Routes', Component: RoutesTab },
  { key: 'targets', label: 'Targets', Component: TargetsTab },
  { key: 'runs', label: 'Run history', Component: RunsTab },
  { key: 'sso', label: 'SSO coverage', Component: SSOCoverageTab }
]

// A drawer's address (/targets/:id, /runs/:id) keeps its own tab underneath.
const DRAWER_TAB = [['/admin/alert-routing/targets/', 'targets'], ['/admin/alert-routing/runs/', 'runs']]

export const AlertRoutingPage = () => {
  const { pathname, search } = useLocation()
  const drawer = DRAWER_TAB.find(([prefix]) => pathname.startsWith(prefix))
  const key = drawer ? drawer[1] : new URLSearchParams(search).get('tab')
  const tab = TABS.find(t => t.key === key) || TABS[0]
  return (
    <FleetPage title="Alert routing" purpose="Who hears about errors, support, single sign-on and contact-form alerts, and how.">
      <nav className="sw-tabs" aria-label="Alert routing">
        {TABS.map(t => <NavLink key={t.key} to={`/admin/alert-routing?tab=${t.key}`} isActive={() => t.key === tab.key} activeClassName="active"
          aria-current={t.key === tab.key ? 'page' : undefined}>{t.label}</NavLink>)}
      </nav>
      <tab.Component />
    </FleetPage>
  )
}
